import type { ReactNode } from 'react';
import classNames from 'styles/utils/classNames';

interface Props {
  title: string;
  children: ReactNode;
  /** `secondary` is the form-field label tone (the request modal's "Select day"). */
  tone?: 'primary' | 'secondary';
  /** `lg`: the heading steps up from lg, for Figma's wider "Modal M". */
  sizeDesktop?: 'lg';
}

/** A titled block in a Find detail modal — heading + body, 12px apart. */
export default function DetailSection({ title, children, tone = 'primary', sizeDesktop }: Props) {
  return (
    <section className="flex flex-col gap-ds-md">
      <h3
        className={classNames(
          'typography-product-subheading',
          sizeDesktop === 'lg' && 'lg:typography-product-heading-compact-desktop',
          tone === 'secondary'
            ? 'text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary'
            : 'text-color-text-lightmode-primary dark:text-color-text-darkmode-primary',
        )}
      >
        {title}
      </h3>
      {children}
    </section>
  );
}
